import React, { createContext, useContext, useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

const DARK_KEY = 'outfit_dark_mode';

export const LIGHT = {
  bg:          '#FFFFFF',
  bgSurface:   '#FAFAF8',
  bgCard:      '#FFFFFF',
  bgRaised:    '#F5F4F0',
  bgBorder:    '#E8E4DC',
  bgSubtle:    '#F0EDE6',
  text:        '#1A1814',
  textSec:     '#4A453D',
  textMuted:   '#7A7268',
  textFaint:   '#A89E94',
  accent:      '#9B7B5A',
  accentLight: '#C4A882',
  accentPale:  '#E8D9C8',
  accentGhost: '#F5EFE8',
  statusBar:   'dark-content',
  tabBg:       '#FFFFFF',
  tabBorder:   '#E8E4DC',
  tabActive:   '#1A1814',
  tabInactive: '#C8C0B4',
  btnPrimary:       '#1A1814',
  btnPrimaryText:   '#FFFFFF',
  btnSecondary:     '#F5F4F0',
  btnSecondaryText: '#1A1814',
  btnBorder:        '#E8E4DC',
};

export const DARK = {
  bg:          '#141414',
  bgSurface:   '#1C1C1C',
  bgCard:      '#222222',
  bgRaised:    '#2A2A2A',
  bgBorder:    '#383838',
  bgSubtle:    '#242424',
  text:        '#EEEEEE',
  textSec:     '#CCCCCC',
  textMuted:   '#999999',
  textFaint:   '#666666',
  // Boutons primaires : fond clair sur fond sombre = lisible
  btnPrimary:       '#EEEEEE',
  btnPrimaryText:   '#141414',
  btnSecondary:     '#2A2A2A',
  btnSecondaryText: '#EEEEEE',
  btnBorder:        '#444444',
  accent:      '#D4B896',
  accentLight: '#E8D9C8',
  accentPale:  '#332A20',
  accentGhost: '#282018',
  statusBar:   'light-content',
  tabBg:       '#1C1C1C',
  tabBorder:   '#383838',
  tabActive:   '#EEEEEE',
  tabInactive: '#666666',
};

const ThemeContext = createContext({
  dark: false,
  theme: LIGHT,
  toggleDark: () => {},
  setDark: () => {},
});

export function ThemeProvider({ children }) {
  const [dark, setDarkState] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    AsyncStorage.getItem(DARK_KEY).then(val => {
      if (val === null) {
        // ═══ Par défaut : mode clair, peu importe les réglages iOS ═══
        // L'utilisateur pourra basculer en sombre via le toggle Profil > Thème.
        setDarkState(false);
      } else {
        setDarkState(val === '1');
      }
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const setDark = async (val) => {
    setDarkState(val);
    await AsyncStorage.setItem(DARK_KEY, val ? '1' : '0');
  };

  const toggleDark = () => setDark(!dark);

  if (!loaded) return null;

  return (
    <ThemeContext.Provider value={{ dark, theme: dark ? DARK : LIGHT, toggleDark, setDark }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
